<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 450px" class="yl-flex flex_between">
                    <Input v-model="name" placeholder="搜索媒体代码名称" style="width: 300px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                    <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
                </div>
                <div style="width: 200px ; display: flex; align-items: center; justify-content: space-around;">
                    <Button class="ivu-btn-circle"  type="primary" @click="save">保存</Button>
                    <Button class="ivu-btn-circle"  @click="countDown">结算该日</Button>
                </div>
            </div>
            <div class="multiple" style="margin-top: 0">
                <div class="multiple">
					<div class="child-div">时间</div>
					<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" placeholder="请选择日期"
								style="width: 200px"></DatePicker>
				</div>
<!--				<div class="multiple" v-if="showCity" style="margin-left: 20px">-->
<!--					<div class="child-div">城市</div>-->
<!--                    <Cascader @on-change="getList" :data="cityData" v-model="city"></Cascader>-->
<!--				</div>-->
            </div>
            <div class="multiple">
                <div class="child-div">下级渠道</div>
                <CheckboxGroup v-model="shopId" style="width: 80%">
                    <Checkbox v-for="item in shopIdList":key="item.value" :label="item.value"><span>{{ item.label }}</span></Checkbox>
                </CheckboxGroup>
            </div>

            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row,index }" slot="settle_money">
                        <Input v-model="datas[index].settle_money" style="width: 100px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="unit_set">
                        <Input v-model="datas[index].cost_money" @on-change="changeCostMoney($event, index)" style="width: 100px"/>
                    </template>
                </Table>
            </div>
        </div>
    </Card>
</template>
<script>
    import {mapGetters} from "vuex";
    import {getMediumCodeCostList, saveMediumCodeDayCost, countCost, getAllShop,saveCost} from "../../api/runSet";
    import cityData from "../../assets/citydata";

	export default {
        name: "advertising_cost",
        components: {},

        data() {
            return {
                showCity: false,
                cityData: cityData,
                unitValue: '',
                shopId: [],
                shopIdList: [],
                modal: false,
                name: '',
                timePeriodDate: '',
                city: [],
                datas: [],
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        "title": "媒体代码",
                        "key": "name"
                    },
                    {
                        "title": "所属渠道",
                        "key": "medium_name",
                    },
                    {
                        "title": "下级渠道",
                        "key": "shop_name",
                    },
                    {
                        "title": "数量",
                        "key": "count",
                    },
                    {
                        "title": "成本单价",
                        "slot": "unit_set",
                    },                    
					{
                        "title": "结算单价",
                        "slot": "settle_money",
                    }


                ],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {
        	this.initDate();
        	this.loadData();
			this.getList();
		},
        methods: {
            timePeriodDateChange(e) {
                this.timePeriodDate = e;
                this.getList();
            },
			initDate() {
				let date = new Date();
				date.setTime(date.getTime());
				this.timePeriodDate = date.getFullYear()+"-" + (date.getMonth() + 1) + "-" + date.getDate();
			},
            initSearch() {
				this.name = '';
				this.initDate();
				this.city = [];
				this.shopId = 0;
            },
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllShop(that, data);
				that.shopIdList = res.data.list;
				that.showCity = true;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getMediumCodeCostList(that, data);
				that.datas = res.data.list;
			},
            changePage() {
				this.page = e;
				this.getList();
            },
            search() {
                this.getList();
            },
            save() {
                let that = this;
                this.$Modal.confirm({
                    title: '确认保存吗？',
                    onOk: async () => {
                        let res = await saveMediumCodeDayCost(that, {token: that.token,date: that.timePeriodDate,  list: that.datas});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.getList();
                        }
                    }
                })
            },
            countDown() {
                let that = this;
                this.$Modal.confirm({
                    title: '确认结算吗？',
                    onOk: async () => {
                        let res = await saveCost(that, {token: that.token, date: that.timePeriodDate, list: that.datas});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.getList();
                        }
                    }
                })
            },
            changeCostMoney(e, index) {
                let item = this.datas[index];
                if (item.settle_type == 2) {
                    this.datas[index].settle_money = item.cost_money * 0.01 * item.settle_proportion;
                }
            }
        },


    }
</script>
<style scoped lang="less">
    .red {
        color: red;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .hong {
        color: #F56171;
        font-weight: bold;
    }

    .lan {
        color: #124386;
        font-weight: bold;
    }

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .ivu-table-header thead tr th {
        text-align: center !important;
    }

    .ivu-table-cell {
        padding-left: 2px;
        padding-right: 2px;
        text-align: center;
    }

    .ivu-table table {
        width: 100% !important;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
</style>
